import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AddEvent() {
  const API_URL = BASE_URL + "/addevent";
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const eventName = formData.get("eventName");
    const sportCategory = formData.get("sportCategory");
    const eventCode = formData.get("eventCode");
    const eventDate = formData.get("eventDate");
    const cityLocation = formData.get("cityLocation");

    if (!eventName || !sportCategory || !eventCode || !eventDate || !cityLocation) {
      toast.error("All fields are required!");
      return;
    }

    const data = {
      eventName,
      sportCategory,
      eventCode,
      eventDate,
      cityLocation, // ✅ NEW
    };

    axios
      .post(API_URL, data, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.message === "Event code already exists") {
          toast.error("This event code already exists!");
        } else {
          toast.success("Event created successfully!");
          setTimeout(() => {
            navigate("/events");
          }, 1200);
        }
      })
      .catch((error) => {
        console.error("Error creating event:", error);
        toast.error("Failed to create event. Please try again.");
      });
  };

  return (
    <div className="container">
      <ToastContainer position="top-center" />
      <h2>Add New Event</h2>
      <br />
      <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-sm-6">
            <input
              type="text"
              placeholder="Enter Event Name"
              className="form-control"
              name="eventName"
              required
            />
          </div>
          <div className="col-sm-6">
            <select className="form-control" name="sportCategory" required defaultValue="">
              <option value="" disabled>
                Select Sport Category
              </option>
              <option value="Baseball">Baseball</option>
              <option value="Basketball">Basketball</option>
              <option value="Football">Football</option>
              <option value="Soccer">Soccer</option>
              <option value="Hockey">Hockey</option>
            </select>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-6">
            <input
              type="text"
              placeholder="Enter Event Code"
              className="form-control"
              name="eventCode"
              required
            />
          </div>
          <div className="col-sm-6">
            <input type="date" className="form-control" name="eventDate" required />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-12">
            <input
              type="text"
              placeholder="Enter City / Location (e.g., Dallas, TX or Chicago - South Complex)"
              className="form-control"
              name="cityLocation"
              required
            />
          </div>
        </div>

        <div className="row">
          <div className="col-sm-3">
            <button type="submit" className="btn btn-primary w-100">
              Create Event
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}